import React, { Component } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const parseData = data => ({
  ...data,
  seo: JSON.parse(data.seo)
})

export default (
  getSlugFromProps,
  getPostType,
  renderNotFound = () => <h1>Not found</h1>
) => WrappedComponent =>
  class WithPost extends Component {
    render() {
      const slug = getSlugFromProps(this.props)
      const endpoint = getPostType(this.props)

      const concertFragment =
        endpoint === 'concert'
          ? `
      concertDate
      ticketLink
      setup {
        title
        link
      }`
          : ''

      return (
        <Query
          query={gql`
            {
              ${endpoint}By(uri: "${slug}"){
                title
                seo
                slug
                backgroundType
                backgroundImage {
                  sourceUrl
                }
                backgroundVideo {
                  mediaItemUrl
                }
                backgroundColor
                backgroundOverlay
                ${concertFragment}
                modules {
                  ...on Modules__header {
                    layout
                    introduction
                    image {
                      sourceUrl
                    }
                  }
                  ...on Modules__pageHeader {
                    layout
                    subTitle
                  }
                  ...on Modules__bodyText {
                    layout
                    columns {
                      body
                      buttons {
                        text
                        layout
                        type
                        externalLink
                        internalLink {
                          ...on Page {
                            link
                          }
                          ...on Concert {
                            link
                          }
                        }
                      }
                    }
                  }
                  ...on Modules__quote {
                    layout
                    quote
                    name
                    title
                  }
                  ...on  Modules__gallery {
                    layout
                    items {
                      image {
                        sourceUrl
                      }
                      hasVideo
                      video
                    }
                  }
                  ...on Modules__imageAndText {
                    layout
                    header
                    body
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Concert{
                          link
                        }
                      }
                    }
                    image {
                      sourceUrl
                      altText
                    }
                    orientation
                  }
                  ...on Modules__distance {
                    layout
                    distance
                  }
                  ...on Modules__tourDates {
                    layout
                  }
                  ...on Modules__concertTeaser {
                    layout
                    link
                  }
                  ...on Modules__releaseTeaser {
                    layout
                    label
                    title
                    image {
                      sourceUrl
                    }
                    releaseDate
                    listenLink
                    presaveLink
                    link
                  }
                  ...on Modules__poelsehjulet {
                    layout
                  }
                }
              }
            }`}
        >
          {({ loading, error, data }) => (
            <div>
              {!error && (data[`${endpoint}By`] || loading) && (
                <WrappedComponent
                  {...this.props}
                  loading={loading}
                  post={
                    data[`${endpoint}By`] && parseData(data[`${endpoint}By`])
                  }
                />
              )}
              {(error || (!loading && !data[`${endpoint}By`])) &&
                renderNotFound()}
            </div>
          )}
        </Query>
      )
    }
  }



// WEBPACK FOOTER //
// ./src/containers/withPost.js